import { ExternalLinkIcon } from "lucide-react";
import { useNavigate, useParams } from "react-router-dom";
import { Button } from "@/components/Base/Button";

export const GoListOpenButton = () => {
  const navigate = useNavigate();
  const { shopId } = useParams();
  return (
    <Button
      variant="default"
      size="icon"
      onClick={() => navigate(`/${shopId}/go-list`)}
      className="ml-2"
      title="Open Go List in new page"
    >
      <ExternalLinkIcon size={18} />
    </Button>
  );
};
